import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { DocumentDto, MsisdnDto, ResultListDto, SearchResultDocumentDto, SearchResultMsisdnDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpSubscriberService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/subscriber', authService);
	}

	searchByDocument(filter: DocumentDto, pageNumber: number, pageSize: number): Observable<ResultListDto<SearchResultDocumentDto>> {
		return super.doPost(true, `/document/search?pageNumber=${pageNumber}&pageSize=${pageSize}`, filter);
	}
	getDocument(documentId: number): Observable<SearchResultDocumentDto> {
		return super.doGet(true, `/document/view/${documentId}`);
	}


	searchByMsisdn(filter: MsisdnDto, pageNumber: number, pageSize: number): Observable<ResultListDto<SearchResultMsisdnDto>> {
		return super.doPost(true, `/msisdn/search?pageNumber=${pageNumber}&pageSize=${pageSize}`, filter);
	}
	getMsisdn(msisdnId: number, personId: number): Observable<SearchResultMsisdnDto> {
		return super.doGet(true, `/msisdn/view/${msisdnId}/${personId}`);
	}


	getFullSubscriber(personId: number): Observable<SubscriberFullDto> {
		return super.doGet(true, `/${personId}`);
	}
	doVerifyDocument(personId: number, document: DocumentDto): Observable<SubscriberFullDto>{
		return super.doGet(true, `/${personId}/verify/${document.id}`);
	}

	uploadCdrCsvFile(personId: number, file: any): Observable<HttpEvent<SubscriberFullDto>>{
		return super.doUploadFile(true, `/${personId}/cdr`, file);
	}

	doUploadImageFront(personId: number, file: any): Observable<HttpEvent<SubscriberFullDto>>{
		return super.doUploadFile(true, `/${personId}/document_front`, file);
	}
	doUploadImageBack(personId: number, file: any): Observable<HttpEvent<SubscriberFullDto>>{
		return super.doUploadFile(true, `/${personId}/document_back`, file);
	}
	doUploadImagePortrait(personId: number, file: any): Observable<HttpEvent<SubscriberFullDto>>{
		return super.doUploadFile(true, `/${personId}/portrait`, file);
	}
	doUploadImageProofOfAddress(personId: number, file: any): Observable<HttpEvent<SubscriberFullDto>>{
		return super.doUploadFile(true, `/${personId}/proof_of_address`, file);
	}
}
